import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { BackendSearchState, SearchAppContext } from '../models/search-models';

export function useSearchList(updateList: any) {
	const app = useContext(SearchAppContext);
	const searchState = useSelector<TcsmStates, BackendSearchState>(state => state?.backendSearchStates[app]);
	useEffect(() => {
		updateList(searchState);
	}, [searchState?.filterPills, searchState?.sorts, searchState?.currentPage]);
}